import React from 'react';

// eslint-disable-next-line max-len
const STARBOX = '/themes/theme/starbox/logo.png';
const STARBOX_DARK_LOGO = '/themes/theme/starbox/logo_dark.png';

const StarboxTheme = {
  headerLogo: {
    src: STARBOX,
    alt: 'Starbox Logo',
    size: 60,
  },
  darkLogo: {
    src: STARBOX_DARK_LOGO,
    alt: 'Starbox Logo',
    size: 60,
  },
  linkStyle: {
    color: '#fff',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#000',
    borderBottom: '4px solid #000',
    height: 100,
  },
  title: 'Starbox',
  isLightOnDark: true,
  organisationId: '928fa5eb-6d12-4382-95f3-d3a80362a73a',
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="60"
        src={STARBOX_DARK_LOGO} alt="Starbox Logo"
      />
      <br /><br />
    </div>
  ),
  shareSite: 'https://share.starbox.co.uk',
};

export default StarboxTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/starbox.js
 **/